module.exports = __webpack_public_path__ + "img/icon_dean_home_bg_card_1_1.78f9272e.png";